export default function StatusBadge({ value, label }) {
  const cls = String(value || "brouillon").replace(/[^a-z_]/gi, "").toLowerCase();
  return <span className={`badge b-${cls}`} data-testid={`badge-${cls}`}>{label || value}</span>;
}
